window.infoLineaPncInyeccion = null;

if (window.location.pathname === "/inyeccion/periodo" || window.location.pathname === "/zona-trabajo") {
    
    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "follow",
    };

    const modalEditarPnc = document.querySelector("#modalEditarPncInyeccion");
    let idLineaProduccion = modalEditarPnc.querySelector("#idLineaPncInyeccion").value;
    
    window.infoLineaPncInyeccion = (idLineaProduccion) => {
        
        const url = `/api/inyeccion/pncInyeccion?idLinea=${idLineaProduccion}`;

        const divModalEditarPnc = document.querySelector("#contEditarPncInyeccion");
        
        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }
                return response.json();
            })
            .then((result) => {

                const data = result.result[0];
                
                const int = n => (Number(n) || 0);
                const dec = n => (Number(n) || '').toLocaleString('en-US',{minimumFractionDigits: 2,maximumFractionDigits: 2});
                const num = n => (Number(n) || '').toLocaleString('en-US');
                const txt = t => String(t ?? '').trim();      
                
                divModalEditarPnc.querySelectorAll('.inputRojo').forEach(input => input.classList.remove('inputRojo'));
                divModalEditarPnc.classList.toggle('canvaBloqueado', Number(data.estadoReporteInyeccion) != 1);
                const contBtnModal = divModalEditarPnc.querySelector('.contBtnModal');
                if (contBtnModal) {
                    contBtnModal.classList.toggle('oculto', Number(data.estadoReporteInyeccion) != 1);
                }
                const horaInicio = divModalEditarPnc.querySelector("#horaInicio");
                const horaFin = divModalEditarPnc.querySelector("#horaFin");
                const idDefecto = divModalEditarPnc.querySelector("#idCausaDefecto");
                const undsDefectuosas = divModalEditarPnc.querySelector("#undsDefectuosas");
                const idCausaContaminacion = divModalEditarPnc.querySelector("#idCausaContaminacion");
                const undsContaminadas = divModalEditarPnc.querySelector("#undsContaminadas");
                const undsCalidad = divModalEditarPnc.querySelector("#undsCalidad");
                const grTorta = divModalEditarPnc.querySelector("#grTorta");
                const obs = divModalEditarPnc.querySelector("#obs");


                if (horaInicio || horaFin || idDefecto || undsDefectuosas || idCausaContaminacion || undsContaminadas || undsCalidad || grTorta || obs) {
                    horaInicio.value = data.horaInicio;
                    horaFin.value = data.horaFin;
                    idDefecto.value = int(data.idCausaDefecto);
                    undsDefectuosas.value = num(data.undsDefectuosas);
                    idCausaContaminacion.value = int(data.idCausaContaminacion);
                    undsContaminadas.value = num(data.undsContaminadas);
                    undsCalidad.value = num(data.undsCalidad);
                    grTorta.value = dec(data.grTorta);
                    obs.textContent = txt(data.observaciones);
                }
            })
            .catch((error) => {
                console.error("Error en la solicitud:", error);
                alert("Ocurrio un error en info línea PNC inyección, contactar al administrador.");
                window.location.href = "/inyeccion";
                return;
            });
    };

    document.addEventListener('click', function (e) {
        const trAbrir = e.target.closest('.trSelectPncInyeccion');
        if (trAbrir) {
            const idLineaProduccion = trAbrir.getAttribute('data-id');
            const modalEditarLineaPnc = document.querySelector('#formEditarPncInyeccion');
            const modalReporteInyeccion = document.querySelector('#formProduccionInyeccion');
            let idPncInyeccion = modalReporteInyeccion.querySelector('#idReporteInyeccion').value;

            if (!idLineaProduccion || !modalEditarLineaPnc || !modalReporteInyeccion || isNaN(idLineaProduccion) || isNaN(idPncInyeccion)) {
                alert("No se encontró el ID de la línea de producción o es inválido.");
                window.location.href = "/inyeccion";
                return;
            }else{
                let inputIdLineaProduccion = modalEditarLineaPnc.querySelector('#idLineaPncInyeccion');
                let inputIdReporteInyeccion = modalEditarLineaPnc.querySelector('#idEncabezadoReporteInyeccion');

                if(inputIdLineaProduccion  || inputIdReporteInyeccion){
                    inputIdLineaProduccion.value = idLineaProduccion;
                    inputIdReporteInyeccion.value = idPncInyeccion;
                    window.infoLineaPncInyeccion(idLineaProduccion);
                }else{
                    alert("No se encontró el campo oculto para el ID del encabezado del reporte.");
                    window.location.href = "/inyeccion";
                    return;
                }
            }
        }
    });
}